import React, { Component } from 'react'
import { Nav } from './Nav';
import MyCalendar from '../MyCalendar';
import MobileShiftList from './MobileShiftList';
import { HoursBox } from './HoursBox';
import { HoursBoxClients } from './HoursBoxClients';
import { AddShiftBox } from './AddShiftBox';
import AddShiftFormDialog from './AddShiftFormDialog'
import { AddAppointmentBox } from './AddAppointmentBox';
import MyAppointments from '../MyAppointments';
import { CaretakerFilter3 } from './CaretakerFilter3';
import './home.css';
import EditAppointmentDialog from './EditAppointmentDialog';
import ConfirmDeleteAppointmentDialog from './ConfirmDeleteAptDialog';
import { ShiftsService } from '../services/supabase/shiftsService';
import { AppointmentsService } from '../services/supabase/appointmentsService';
import { UserService } from '../services/user/userService';
import { mapShiftRow } from '../utils/shiftUtils';
import QuickBooksConnect from './QuickBooksConnect';

export default class Home extends Component {

    constructor(props) {
        super(props);
        this.InitialLoadShifts = this.InitialLoadShifts.bind(this);
        this.InitialLoadUsers = this.InitialLoadUsers.bind(this);
    }

    componentDidMount() {
        this.props.loadCaretakers();
        this.props.loadClients();
        this.InitialLoadShifts();
        this.InitialLoadAppointments();
    }

    async InitialLoadUsers() {
        const rows = await UserService.getUsers();
        const users = rows.map(row => ({
            name: row.name,
            email: row.email,
            type: row.type,
            docID: row.id,
            isDeactivated: row.is_deactivated
        }));
        this.props.setUserList(users);
    }

    async InitialLoadShifts() {
        const isAdmin = this.props.checkAdminPriviledge();

        if (isAdmin) {
            const currWeekStartTime = new Date(Date.now());
            const currWeekEndTime = new Date(Date.now());
            const currentDOW = currWeekStartTime.getDay();

            const startOffsets = { 5: -7, 6: -8, 0: -10, 1: -11, 2: -12, 3: -13, 4: -14 };
            const endOffsets   = { 5: 14,  6: 13,  0: 12,  1: 11,  2: 10,  3: 9,   4: 8  };

            currWeekStartTime.setDate(currWeekStartTime.getDate() + (startOffsets[currentDOW] ?? 0));
            currWeekEndTime.setDate(currWeekEndTime.getDate() + (endOffsets[currentDOW] ?? 0));
            currWeekStartTime.setHours(0, 0, 0, 0);
            currWeekEndTime.setHours(0, 0, 0, 0);

            this.props.setCurrWeekStartTimeSecs(currWeekStartTime.getTime());
            this.props.setCurrWeekEndTimeSecs(currWeekEndTime.getTime());

            const rows = await ShiftsService.getShiftsForAdmin();
            const shifts = rows.map(mapShiftRow);
            this.props.setEventList(shifts);
            this.props.setMasterEventList(shifts);
        } else {
            const rows = await ShiftsService.getShiftsForCaretaker(this.props.user.email);
            const shifts = rows.map(mapShiftRow);
            this.props.setEventList(shifts);
            this.props.setMasterEventList(shifts);
        }
    }

    async InitialLoadAppointments() {
        const rows = await AppointmentsService.getAll();
        const apts = rows.map(row => ({
            client: row.client,
            start: row.start_time,
            end: row.end_time,
            details: row.details,
            addedBy: row.added_by,
            aptLabel: row.apt_label,
            aptID: row.id
        }));
        this.props.setAppointmentList(apts);
    }

    render() {
        return (
            <div id="homeDiv">
                {this.props.checkAdminPriviledge() && <Nav />}
                {this.props.checkAdminPriviledge() && (
                  <div style={{ marginLeft: '10vw', paddingTop: '1vh' }}>
                    <QuickBooksConnect onStatusChange={this.props.onQbStatusChange} />
                  </div>
                )}
                <h1 id="schedulingH1">Scheduling</h1>

                {this.props.checkAdminPriviledge() &&
                    <CaretakerFilter3
                        caretakerListNames={this.props.caretakerListNames}
                        filterSelected={this.props.filterSelected}
                        setFilterButtons={this.props.setFilterButtons}
                        eventList={this.props.eventList}
                        setEventList={this.props.setEventList}
                        filteredEventList={this.props.filteredList}
                        setFilteredEventList={this.props.setFilteredList}
                        masterEventList={this.props.masterEventList}
                        setMasterEventList={this.props.setMasterEventList}
                        setFilterButtonsArray={this.props.setFilterButtonsArray}
                        caretakerMasterList={this.props.caretakerMasterList}
                        caretakerMasterListNames={this.props.caretakerMasterListNames}
                        currentStartDate={this.props.currentStartDate}
                        clientListNames={this.props.clientListNames}
                        clientMasterList={this.props.clientMasterList}
                        filterButtonsClient={this.props.filterButtonsClient}
                        setFilterButtonsClient={this.props.setFilterButtonsClient}
                        setFilterButtonsArrayClient={this.props.setFilterButtonsArrayClient}
                    />
                }

                <div className="scheduleDiv">

                    {(!this.props.checkAdminPriviledge() && window.matchMedia('(max-width: 768px)').matches)
                      ? <MobileShiftList eventList={this.props.eventList} />
                      : <MyCalendar
                            eventList={this.props.eventList}
                            getTimeAndDate={this.props.getTimeAndDate}
                            displayDialog={this.props.displayDialog}
                            setDisplayDialog={this.props.setDisplayDialog}
                            setEventClickedObject={this.props.setEventClickedObject}
                            prettifyTime={this.props.prettifyTime}
                            user={this.props.user}
                            checkAdminPriviledge={this.props.checkAdminPriviledge}
                            caretakerListNames={this.props.caretakerListNames}
                            filterSelected={this.props.filterSelected}
                            InitialLoadShifts={this.InitialLoadShifts}
                        />
                    }

                    {this.props.checkAdminPriviledge() &&
                        <AddShiftBox
                            addShift={this.props.addShift}
                            clientList={this.props.clientList}
                            caretakerList={this.props.caretakerList}
                            caretakerMasterList={this.props.caretakerMasterList}
                            caretakerMasterListNames={this.props.caretakerMasterListNames}
                            renderRepeatOptions={this.props.renderRepeatOptions}
                            setRenderRepeatOptions={this.props.setRenderRepeatOptions}
                            setRenderFlatFeeOptions={this.props.setRenderFlatFeeOptions}
                            renderFlatFeeOptions={this.props.renderFlatFeeOptions}
                            caretakerListNames={this.props.caretakerListNames}
                            renderOvernightOptions={this.props.renderOvernightOptions}
                            setRenderOvernightOptions={this.props.setRenderOvernightOptions}
                        />
                    }

                    {this.props.checkAdminPriviledge() &&
                        <HoursBox
                            caretakerList={this.props.caretakerList}
                            currentStartDate={this.props.currentStartDate}
                            currentEndDate={this.props.currentEndDate}
                            currentStartTimestr={this.props.currentStartTimestr}
                            currentEndTimestr={this.props.currentEndTimestr}
                            eventList={this.props.eventList}
                            caretakerMasterList={this.props.caretakerMasterList}
                            clientList={this.props.clientList}
                        />
                    }

                    {this.props.checkAdminPriviledge() &&
                        <HoursBoxClients
                            clientList={this.props.clientList}
                            currentStartDate={this.props.currentStartDate}
                            currentEndDate={this.props.currentEndDate}
                            currentStartTimestr={this.props.currentStartTimestr}
                            currentEndTimestr={this.props.currentEndTimestr}
                            eventList={this.props.eventList}
                        />
                    }

                    {
                        <AddShiftFormDialog
                            displayDialog={this.props.displayDialog}
                            setDisplayDialog={this.props.setDisplayDialog}
                            eventClickedObject={this.props.eventClickedObject}
                            editTimeWorked={this.props.editTimeWorked}
                            checkAdminPriviledge={this.props.checkAdminPriviledge}
                            deleteShift={this.props.deleteShift}
                            deleteFutureShifts={this.props.deleteFutureShifts}
                            caretakerList={this.props.caretakerList}
                            caretakerListNames={this.props.caretakerListNames}
                            eventList={this.props.eventList}
                            editInfoForShift={this.props.editInfoForShift}
                            clientListNames={this.props.clientListNames}
                        />
                    }

                    {
                        <MyAppointments
                            aptEventList={this.props.appointmentList}
                            user={this.props.user}
                            prettifyTime={this.props.prettifyTime}
                            getTimeAndDate={this.props.getTimeAndDate}
                            displayEditAppointmentDialog={this.props.displayEditAppointmentDialog}
                            setDisplayEditAppointmentDialog={this.props.setDisplayEditAppointmentDialog}
                            setAptClickedObject={this.props.setAptClickedObject}
                            aptClickedObject={this.props.aptClickedObject}
                        />
                    }

                    {
                        <EditAppointmentDialog
                            setDisplayEditAppointmentDialog={this.props.setDisplayEditAppointmentDialog}
                            displayEditAppointmentDialog={this.props.displayEditAppointmentDialog}
                            appointmentList={this.props.appointmentList}
                            aptClickedObject={this.props.aptClickedObject}
                            deleteApt={this.props.deleteApt}
                            setAptToDeleteID={this.props.setAptToDeleteID}
                            setDisplayConfirmDeleteAppointmentDialog={this.props.setDisplayConfirmDeleteAppointmentDialog}
                            editAptNotes={this.props.editAptNotes}
                        />
                    }

                    {
                        <ConfirmDeleteAppointmentDialog
                            setDisplayConfirmDeleteAppointmentDialog={this.props.setDisplayConfirmDeleteAppointmentDialog}
                            displayConfirmDeleteAppointmentDialog={this.props.displayConfirmDeleteAppointmentDialog}
                            deleteApt={this.props.deleteApt}
                        />
                    }

                    {
                        <AddAppointmentBox
                            addShift={this.props.addShift}
                            clientList={this.props.clientList}
                            addAppointment={this.props.addAppointment}
                            user={this.props.user}
                            userList={this.props.userList}
                        />
                    }

                </div>
            </div>
        )
    }
}
